export function getBaseMapStyle(base) {
  if (base === "maptiler") {
    return "https://api.maptiler.com/maps/0199928a-49db-7431-b55f-44613eb72e69/style.json?key=HXgK2fqnmExz8Z5kpMyR";
  }

  const sources = {
    carto: {
      tiles: [
        "https://cartodb-basemaps-a.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png",
      ],
      tileSize: 256,
      attribution: "© Carto",
      overlayTrails: true,
    },
    osm: {
      type: "raster",
      tiles: ["https://tile.openstreetmap.org/{z}/{x}/{y}.png"],
      tileSize: 256,
      attribution: "© OpenStreetMap Contributors",
      overlayTrails: true,
    },
  };
  const style = {
    version: 8,
    sources: {
      osm: {
        type: "raster",
        tiles: sources[base].tiles,
        tileSize: sources[base].tileSize,
        attribution: sources[base].attribution,
      },
      ski: {
        type: "raster",
        tiles: ["https://tiles.opensnowmap.org/pistes/{z}/{x}/{y}.png"],
        tileSize: 256,
        attribution: "© OpenSnowMap",
      },
      elevation: {
        type: "raster-dem",
        tiles: [
          "https://s3.amazonaws.com/elevation-tiles-prod/terrarium/{z}/{x}/{y}.png",
        ],
        tileSize: 256,
        encoding: "terrarium",
        attribution: "© Mapzen Terrain Tiles",
        maxzoom: 14,
      },
    },
    layers: [
      {
        id: "osm",
        type: "raster",
        source: "osm",
        minzoom: 0,
        maxzoom: 19,
      },
      {
        id: "hillshade",
        type: "hillshade",
        source: "elevation",
        paint: {
          "hillshade-shadow-color": "#666",
          "hillshade-highlight-color": "#fff",
          "hillshade-accent-color": "#888",
          "hillshade-exaggeration": 0.5,
        },
      },
    ],
  };

  if (sources[base].overlayTrails) {
    style.layers.push({
      id: "ski-overlay",
      type: "raster",
      source: "ski",
      minzoom: 0,
      maxzoom: 19,
    });
  }
  return style;
}
